import { render, staticRenderFns } from "./ManagersTopDownReport.vue?vue&type=template&id=708c5fae&scoped=true"
import script from "./ManagersTopDownReport.vue?vue&type=script&lang=js"
export * from "./ManagersTopDownReport.vue?vue&type=script&lang=js"
import style0 from "./ManagersTopDownReport.vue?vue&type=style&index=0&id=708c5fae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708c5fae",
  null
  
)

export default component.exports